<template>
  <div class="nsale_ myPage_ teamM_">
    <div class="form_">
      <div class="input_ input_rel1" v-if="edit">
        <div class="text_">账号名称：</div>
        <cube-input
          class="inputStyle"
          v-model="form.name"
          placeholder="请输入账号名称"
        ></cube-input>
      </div>
      <div class="input_" v-else>
        <div class="text_">账号名称：</div>
        <div class="inputStyle inputStyle2">
          {{ form.name | filterNull }}
        </div>
      </div>

      <!-- <div class="input_ input_rel1" v-if="edit">
        <div class="text_">账号：</div>
        <cube-input class="inputStyle" placeholder="18310427766"></cube-input>
      </div> -->
      <div class="input_">
        <div class="text_">账号：</div>
        <div class="inputStyle inputStyle2">
          {{ form.loginName | filterNull }}
        </div>
      </div>

      <div class="input_ input_rel1" v-if="edit">
        <div class="text_">联系人：</div>
        <cube-input
          class="inputStyle"
          v-model="form.linkman"
          placeholder="请输入联系人"
        ></cube-input>
      </div>
      <div class="input_" v-else>
        <div class="text_">联系人：</div>
        <div class="inputStyle inputStyle2">
          {{ form.linkman | filterNull }}
        </div>
      </div>

      <div class="input_ input_rel1" v-if="edit">
        <div class="text_">电子邮箱：</div>
        <cube-input
          class="inputStyle"
          v-model="form.email"
          placeholder="请输入电子邮箱"
        ></cube-input>
      </div>
      <div class="input_" v-else>
        <div class="text_">电子邮箱：</div>
        <div class="inputStyle inputStyle2">
          {{ form.email | filterNull }}
        </div>
      </div>

      <!-- <div class="input_ input_rel1" v-if="edit">
        <div class="text_">手机号码：</div>
        <cube-input
          class="inputStyle"
          v-model="form.phone"
          placeholder="请输入手机号码"
        ></cube-input>
      </div> -->
      <div class="input_">
        <div class="text_">手机号码：</div>
        <div class="inputStyle inputStyle2">
          {{ form.phone | filterNull }}
        </div>
      </div>

      <!-- <div class="input_ input_rel1" v-if="edit">
        <div class="text_">适用模版：</div>
        <cube-input class="inputStyle" placeholder="金九模版"></cube-input>
      </div> -->
      <div class="input_">
        <div class="text_">适用模版：</div>
        <div class="inputStyle inputStyle2">
          {{ form.teamTemplateName | filterNull }}
        </div>
      </div>

      <!-- <div class="input_ input_rel1" v-if="edit">
        <div class="text_">创建时间：</div>
        <cube-input class="inputStyle" placeholder="2020-003-04 12:30:56"></cube-input>
      </div> -->
      <div class="input_">
        <div class="text_">创建时间：</div>
        <div class="inputStyle inputStyle2">
          {{ form.createDate }}
        </div>
      </div>

      <!-- <div class="input_ input_rel1" v-if="edit">
        <div class="text_">认证情况：</div>
        <cube-input class="inputStyle" placeholder="认证"></cube-input>
      </div> -->
      <div class="input_">
        <div class="text_">资质认证：</div>
        <div class="inputStyle inputStyle2">
          {{ form.authenticationFlag | filterAuth }}
        </div>
      </div>

      <div class="input_ input_rel1" v-if="edit" @click="showPicker">
        <div class="text_">使用情况：</div>
        <div
          class="inputStyle inputStyle2"
          style="margin-right:10px"
          :class="[form.forbiddenType == '1' ? 'red_' : 'green_']"
        >
          {{ form.forbiddenType | filterForbidden }}
        </div>
        <img class="i_img" src="../../../assets/image/nsale/down.png" alt="" />
      </div>
      <div class="input_" v-else>
        <div class="text_">使用情况：</div>
        <div
          class="inputStyle inputStyle2"
          :class="[form.forbiddenType == '1' ? 'red_' : 'green_']"
        >
          {{ form.forbiddenType | filterForbidden }}
        </div>
      </div>
    </div>

    <div v-if="edit">
      <cube-button class="btn_" @click="save">保存</cube-button>
      <div class="cancel" @click="goback">取消</div>
    </div>
    <cube-button v-else class="btn_" @click="handleEdit">编辑</cube-button>
  </div>
</template>

<script>
import api from "@/utils/api";
import moment from "moment";
const column1 = [{ text: "禁用", value: "1" }, { text: "启用", value: "2" }];
export default {
  data() {
    return {
      id: "",
      edit: false,
      form: {
        // id: "720101",
        // name: "user001",
        // loginName: "user001",
        // linkman: "张三1",
        // contactInformation: "13654754524",
        // phone: "13566666666",
        // password: null,
        // teamTemplateId: null,
        // teamTemplateName: "00990",
        // accountType: null,
        // netFeeType: null,
        // settleType: null,
        // forbiddenType: "0",
        // authenticationFlag: "1",
        // searchChars: null,
        // creator: null,
        // createDate: 1583203644000,
        // ids: null,
        // params: null,
        // imageUrl: null,
        // referrer: null
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter -->", to, from);
    next();
  },
  activated() {
    console.log("activated -> ", 1, this.$route);
  },
  //   beforeRouteLeave(to, from, next) {
  //     console.log("beforeRouteLeave -->", to, from, next);
  //     next();
  //   },
  filters: {
    filterForbidden(val) {
      if (val == "1") {
        return "禁用";
      } else if (val == "0" || val == "2") {
        return "启用";
      }
    },
    filterAuth(val) {
      if (val == "1") {
        return "已认证";
      } else if (val == '3') {
        return '不适用'
      } else {
        return "未认证"
      }
    },
    filterTime(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    filterNull(val) {
      if (val == "" || val == null) {
        return "无";
      } else {
        return val;
      }
    }
  },
  mounted() {
    this.hideOptionMenu();
    this.id = this.$route.params.id;
    this.edit = this.$route.meta.edit;
    this.getDetail();
  },
  methods: {
    hideOptionMenu() {
      try {
        WeixinJSBridge.call("hideOptionMenu");
      } catch (error) {}
    },
    getDetail() {
      api.getUserDetailByUserId(this.id).then(res => {
        this.form = res.data.content;
      });
    },
    save() {
      //   this.edit = !this.edit;
      console.log(this.form, "-->form");
      let data = {
        id: this.id,
        name: this.form.name,
        linkman: this.form.linkman,
        email: this.form.email,
        phone: this.form.phone,
        forbiddenType: this.form.forbiddenType
      };
      let emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (this.form.name == "") {
        this.showToast("请输入账号名称");
      } else if (this.form.linkman == "") {
        this.showToast("请输入联系人");
      }  else if (!emailReg.test(this.form.email)) {
        this.showToast("请输入正确格式的邮箱");
      }else {
        this.updateUser(data);
      }
    },
    showToast(text) {
      this.$createToast({
        txt: text,
        time: 1000,
        type: "txt"
      }).show();
    },
    updateUser(data) {
      api.updateUser(data).then(res => {
        this.showToast("操作成功");
        this.$router.push({ path: `/nsale/detail/${this.id}` });
      });
    },
    goback() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.$router.push({ path: `/nsale/edit/${this.id}` });
    },
    showPicker() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: "选择",
          data: [column1],
          onSelect: this.selectHandle
        });
      }
      this.picker.show();
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      console.log(selectedVal, selectedIndex, selectedText);
      this.form.forbiddenType = selectedVal[0];
    }
  }
};
</script>

<style scoped lang="scss">
.nsale_ {
  font-family: PingFang SC;
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
}
.btn_ {
  width: 305px;
  height: 50px;
  background: rgba(255, 74, 53, 1);
  border-radius: 5px;
  margin: 10px auto;
}
.cancel {
  font-size: 15px;
  color: rgba(255, 74, 53, 1);
  margin: 0 auto;
}
.form_ {
  padding: 0px 35px;
  background: #fff;
  .i_img {
    height: 7px;
    width: auto;
  }
  .input_ {
    width: 305px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f7f7f7;
    .text_ {
      font-size: 15px;
      color: rgba(51, 51, 51, 1);
      width: 100px;
      text-align: left;
      height: 40px;
      line-height: 17px;
      display: flex;
      align-items: center;
    }

    .inputStyle {
      font-size: 15px;
      color: #cccccc;
      height: 36px;
      width: 192px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: left;
    }
    .inputStyle1 {
      height: 94px;
      width: 285px;
    }
    .inputStyle2 {
      font-size: 15px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .red_ {
    color: #ff4a35 !important;
  }
  .green_ {
    color: #00be28 !important;
  }
}
</style>
